<template>
  <div>
    <v-flex xs12>
      <h2 class="text-center mb-3">Signering</h2>
      <div v-if="readyForSigning" class="text-center mb-2">
        <v-btn color="success" @click="openPdf()" :loading="pdfButtonLoader">
          Forhåndsvis protokoll<v-icon class="pl-3">mdi-file-pdf</v-icon>
        </v-btn>
      </div>
      <div v-html="config.info" v-if="config.info" class="mb-3"></div>
      <h4 v-if="showSignBoxes" class="text-center mb-3">Signering gjøres ved at hver deltaker skriver sin underskrift i boksen ved sitt navn.</h4>
      <div
        v-if="digitalSignature && readyForSigning && showSignSelects"
        class="text-center mb-3"
      ><h3 class="mb-4">Velg mellom følgende signeringsalternativer:</h3>
      <v-card class="mb-4">
        <v-toolbar color="accent" :dark="protocol.dark">
          <v-toolbar-title>1: BankID</v-toolbar-title>
        </v-toolbar>
        <v-card-text>
          <h5>
            <p>
              Opprett digital signatur med BankID ved å trykke på knappen under.<br />
              Protokollen blir da satt til fullført, og man kan ikke lenger redigere denne.
            </p>
            <p>
              PDF av protokollen vil bli generert <br />og må signeres digitalt med BankID eller BankID på mobil.
            </p>
            <p>
              Sørg for at alle deltakere har gyldig BankID før dette velges.
            </p>
          </h5>
          <img src="https://res.cloudinary.com/presis-utleie/image/upload/c_scale,w_150/v1583758083/logo/eyJwYXRoIjoiXC9wdWJsaWNcL3VwbG9hZFwvc2NyZWVuc1wvMjEzNjI3XC8wYWZmNDZiNjM1NTIzMjQzNDQ3NzAxY2NkY2Y4YmZiMy0xNTcxNjgzMjE0LnBuZyJ9_frontify_gimudEjG9KLTjCE_cey6-PcMS4B7t2-7JT4CAaEv9bQ.png" />
          
          <v-btn v-if="$store.state.online" color="primary" text @click="createDigitalSign" :loading="loader" :disabled="loader">Signer med BankID</v-btn>
          <v-alert v-else :value="true" color="warning" type="warning">
            Internett-tilkobling er ikke aktiv: Det ser ikke ut til at du er på nett, og kan derfor ikke fullføre protokollen.
            Sørg for at du er et sted med dekning, eller er tilkoblet internett.
          </v-alert>
        </v-card-text>
      </v-card>
      <v-card class="mb-3">
        <v-toolbar color="accent" :dark="protocol.dark">
          <v-toolbar-title>2: Signer med finger</v-toolbar-title>
        </v-toolbar>
        <v-card-text>
          <h5>
            <p>
              Signering gjøres ved at hver deltaker skriver sin underskrift i boksen ved sitt navn.
            </p>
            <p>
              Dette gjøres ved å bruke en finger for å skrive signatur.
            </p>
          </h5>
            <v-btn v-if="$store.state.online" color="primary" text @click="selectSignBoxes" :loading="loader" :disabled="loader">Signer med finger</v-btn>
            <v-alert v-else :value="true" color="warning" type="warning">
              Internett-tilkobling er ikke aktiv: Det ser ikke ut til at du er på nett, og kan derfor ikke fullføre protokollen.
              Sørg for at du er et sted med dekning, eller er tilkoblet internett.
            </v-alert>
        </v-card-text>
      </v-card>
      </div>
    </v-flex>
    <div v-if="readyForSigning && renderComponent && showSignBoxes">
      <template v-for="(item, index) in people">
        <v-flex xs12 class="mb-4" :key="index+'1'">
          <v-card>
            <v-toolbar color="accent" :dark="protocol.dark">
              <v-toolbar-title v-if="item.companyName">{{item.companyName}}</v-toolbar-title>
              <v-toolbar-title v-else>{{item.firstname}} {{item.lastname}}</v-toolbar-title>
              <v-spacer></v-spacer>
              <v-toolbar-side-icon>
                <v-icon @click="clearSignature(index)">mdi-pencil-off</v-icon>
              </v-toolbar-side-icon>
            </v-toolbar>
            <vueSignature
              ref="signature"
              :sigOption="signOptions"
              :w="'100%'"
              :h="'300px'"
              :fromDataURL="item.signature"
              :disabled="item.notPresent"
              v-show="!item.notPresent"
            ></vueSignature>
            <v-card-actions class="accent text-white" >
              <v-checkbox
                style="margin-top:0px;"
                hide-details
                color="white"
                v-model="item.notPresent"
                label="Ikke til stede"
                :dark="!protocol.dark"
              ></v-checkbox>
            </v-card-actions>
          </v-card>
        </v-flex>
      </template>
    </div>
    <div v-if="!readyForSigning">
      <v-alert :value="true" color="warning" type="warning">
        Alle sider i protokollen må være fullført før signering kan gjennomføres.
        Du kan enkelt se i menyen hvilke sider som trenger gjennomgang.
      </v-alert>
    </div>
    <v-flex xs12 class="text-center">
      <v-btn flat small @click="previous">Forrige</v-btn>
      <v-btn v-if="$store.state.online && readyForSigning && showSignBoxes" large :loading="loader" :disabled="loader" color="success" @click="doSigning">
        Godkjenn og fullfør protokoll
        <template v-slot:loader>
          <span class="custom-loader">
            <v-icon light>mdi-loading</v-icon>
          </span>
        </template>
      </v-btn>
      <v-alert v-if="!$store.state.online" :value="true" color="warning" type="warning">
        Internett-tilkobling er ikke aktiv: Det ser ikke ut til at du er på nett, og kan derfor ikke fullføre protokollen.
        Sørg for at du er et sted med dekning, eller er tilkoblet internett.
      </v-alert>
    </v-flex>
    <v-dialog v-model="dialog" fullscreen hide-overlay transition="dialog-bottom-transition">
      <v-toolbar :dark="protocol.dark" color="primary">
        <v-toolbar-title>Protokoll fullført</v-toolbar-title>
        <v-spacer></v-spacer>
      </v-toolbar>
      <v-card>
        <v-card-text>
          <v-flex cs12 align-center text-center>
            <img :src="protocol.logo" class="mb-3 logo-img" />
          </v-flex>
          <v-flex xs12 sm8 offset-sm2 align-center text-center>
            <h1>Gratulerer!</h1>
          </v-flex>
          <v-flex xs12 sm8 offset-sm2 align-center text-center>
            <h3>
              Protokollen er nå gjennomført.
            </h3>
          </v-flex>
        </v-card-text>
      </v-card>
    </v-dialog>
    <v-dialog v-model="notCompleteDialog" persistent max-width="290">
      <v-card>
        <v-card-title class="headline">Signering</v-card-title>
        <v-card-text>Alle parter må signere protokollen</v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="primary" text @click="notCompleteDialog = false">OK</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import step from "../../mixins/step";
import * as axios from 'axios';
export default {
  mixins: [step],
  data() {
    return {
      showSignBoxes: false,
      showSignSelects: true,
      dialog: false,
      pdfButtonLoader: false,
      previewUrl: null,
      notCompleteDialog: false,
      loader: false,
      signOptions: {
        penColor: "rgb(0, 0, 0)",
        backgroundColor: "rgb(255,255,255)"
      },
      readyForSigning: false,
      renderComponent: true
    };
  },
  mounted: function() {
    this.previewUrl = process.env.VUE_APP_BACKEND_URL + 'protocols/previewPdf/' + this.protocol.hash
    this.readyForSigning = this.stepsFinished();
    if(!this.digitalSignature) {
      this.showSignBoxes = true
    }
  },
  activated: function() {
    this.renderComponent = false;
    this.readyForSigning = this.stepsFinished();
    this.$nextTick(() => {
      // Add the component back in
      this.renderComponent = true;
    });
  },
  computed: {
    people: function() {
      let peopleList = [];
      for(let type in this.protocol.saved_values.participants) {
        for(let person in this.protocol.saved_values.participants[type]) {
          if(this.protocol.saved_values.participants[type][person].phone) {
             peopleList.push(this.protocol.saved_values.participants[type][person])
          }
        }
      }
      return peopleList;
    },

    allSigned: function() {
      let all = true;
      let some = false
      for (let key in this.people) {
        if(this.people[key].notPresent != undefined && this.people[key].notPresent != null) {
          if(this.people[key].notPresent) {
            continue
          }
        }
        if (!this.$refs.signature[key].isEmpty()) {
          let png = this.$refs.signature[key].save();
          this.setSignature(key, png);
          some = true
        } else {
          all = false;
        }
      }
      if(some) {
        return all;
      }
      return false
    },
    digitalSignature: function() {
      if(this.stepValues.signatureMethods) {
        if(this.stepValues.signatureMethods.includes('bankId')) {
          return true
        }
      }
      return false
    }
  },
  components: {},
  methods: {
    openPdf () {
			this.pdfButtonLoader = true
			this.axios.get(process.env.VUE_APP_BACKEND_URL + 'protocols/previewPdf/' + this.protocol.hash, { responseType: 'blob' })
				.then((res) => {
					this.pdfReady(res)
				}).catch((error) => {
					console.log(error.response)
					this.pdfReady(error.response)
				})
    },
    pdfReady(res) {
      if (res.error) {
        this.$emit(
              "error",
              res.error
            );
			}
			else {
				const blob = new Blob([res.data], { type: 'application/pdf' })
				const fileURL = URL.createObjectURL(blob)
				window.open(fileURL)
			}
			this.pdfButtonLoader = false
    },
    stepsFinished() {
      let index = 0;
      for (let step in this.protocol.saved_values.steps) {
        if(step !== 'signing')
        if (!this.protocol.saved_values.steps[step].finished) {
          return false;
        }
      }
      return true;
    },
    createDigitalSign() {
      this.loader = true;
      this.$emit("page-finished");
      if (this.stepsFinished()) {
        this.axios
          .post(
            process.env.VUE_APP_PROTOCOL_API +
              "protocols/" +
              this.$store.state.protocolHash +
              "/createSign",
            this.$store.state.protocol.saved_values
          )
          .then(response => {
            if(response.data.status == "ok") {
              this.$emit('showDigitalSignature', response.data.sign_request.request);
            }
            else {
              this.loader = false;
              this.$emit(
                "error",
                "Det skjedde en feil ved opprettelse av digital signatur"
              );
            }
          })
          .catch(error => {
            this.loader = false;
            this.$emit(
              "error",
              error
            );
          });
      } else {
        this.loader = false;
        this.$emit(
          "error",
          "Alle steg må være ferdig utfylt før protokollen kan fullføres. Du kan se i menyen hvilke steg som ikke er ferdige."
        );
      }
    },
    selectSignBoxes() {
      this.showSignBoxes = true
      this.showSignSelects = false
    },
    clearSignature(index) {
      this.$refs.signature[index].clear()
    },
    doSigning() {
      this.loader = true;
      if (this.allSigned) {
        this.$emit("page-finished");
        if (this.stepsFinished()) {
          this.axios
            .post(
              process.env.VUE_APP_PROTOCOL_API +
                "protocols/" +
                this.$store.state.protocolHash +
                "/finished",
              this.$store.state.protocol.saved_values
            )
            .then(response => {
              this.dialog = true;
              this.$ga.event(
                "protocol",
                "protocol_signed",
                this.$store.state.protocolHash
              );
              return response;
            })
            .catch(error => {
              this.loader = false;
              this.$emit(
                "error",
                "Det skjedde en feil ved signering av protokoll. Sørg for at du er koblet til internett og forsøk på nytt"
              );
            });
        } else {
          this.loader = false;
          this.$emit(
            "error",
            "Alle steg må være ferdig utfylt før protokollen kan fullføres. Du kan se i menyen hvilke steg som ikke er ferdige."
          );
        }
      } else {
        this.loader = false;
        this.notCompleteDialog = true;
      }
    },
    previous: function() {
      this.$emit("previous-page");
    },
    setSignature: function(key, signature) {
      this.people[key].signature = signature;
    }
  }
};
</script>
